import { AddressFormFieldControl } from "../../../api";
import {
	AddressAutocompleteInput,
	type AddressAutocompleteInputProps,
} from "../inputs/AddressAutocompleteInput";

export type FormAddressAutocompleteProps = {
	control: AddressFormFieldControl;
	readonly?: boolean;
	placeholder?: string;
	className?: string;
	compact?: boolean;
	anchor?: AddressAutocompleteInputProps["anchor"];
};

export const FormAddressAutocomplete = ({ control, ...props }: FormAddressAutocompleteProps) => (
	<AddressAutocompleteInput {...props} {...control} />
);
